'use strict';
const Rect = require('./rect');
module.exports = function nodeToRectConverter(params) {
	const {node, margin, parent} = params,
		parentNode = parent || node,
		left = Math.floor(Math.min(node.x, parentNode.x + parentNode.width) - margin),
		right = Math.ceil(Math.max(node.x + node.width, parentNode.x) + margin),
		top = Math.floor(Math.min(node.y, parentNode.y + parentNode.height) - margin),
		bottom = Math.ceil(Math.max(node.y + node.height, parentNode.y) + margin),
		result = new Rect({top, left, bottom, right});
	return result;
};
